import Vue from 'vue'
import axios from 'axios'
import i18n from '@/i18n'

export default {
  baseURL: process.env.BASE_URL + "api/dashboard",

  getDashboard(filter, cancelToken, localizationId) {
    return axios
      .get("dashboarddataaldisued", {
        baseURL: this.baseURL,
        params: {
          "localization-id": localizationId || i18n.locale,
          "client-id": filter ? (filter.client || null) : null,
          "project-ids": filter ? (filter.projects || null) : null,
          "survey-ids" : filter ? (filter.surveys || null) : null,
          "wave-ids" : filter ? (filter.waves || null) : null,
          "custompropertyvalue-ids": filter ? (filter.customProperties || null) : null,
          "clientlocation-ids": filter ? (filter.locations || null) : null
        },
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function(response) {
        return response;
      })
      .catch(function(error) {
        console.log(error);
      });
  },

  getApplicationManual(localizationId, documentVariant, cancelToken) {
    return axios
      .get("manual", {
        baseURL: this.baseURL,
        params: {
          "localization-id": localizationId || i18n.locale,
          "documentvariant": documentVariant
        },
        responseType: "blob",
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function(response) {
        return response;
      })
      .catch(function(error) {
        console.log(error);
      });
  },

  getOptions(localizationId, filter, cancelToken) {
    
    let customProps = null;
    if (filter) {
      if (filter.project) {
        customProps = filter.project;
      }
      // SURVEYS not supported here
      // if (!_.isEmpty(filter.surveys)) {
      //   customProps = customProps + "|" + filter.surveys;
      // }
      if (!_.isEmpty(filter.regions)) {
        customProps = customProps + "|" + filter.regions;
      }
      if (!_.isEmpty(filter.subregions)) {
        customProps = customProps + "|" + filter.subregions;
      }
      if (!_.isEmpty(filter.nscs)) {
        customProps = customProps + "|" + filter.nscs;
      }
      if (!_.isEmpty(filter.nscsub)) {
        customProps = customProps + "|" + filter.nscsub;
      }
      if (!_.isEmpty(filter.areas)) {
        customProps = customProps + "|" + filter.areas;
      }
      if (!_.isEmpty(filter.dealergroups)) {
        customProps = customProps + "|" + filter.dealergroups;
      }
      // OUTLET not supported here
      // if (!_.isEmpty(filter.outlets)) {
      //   customProps = customProps + "|" + filter.outlets;
      // }
    } else {

    }
    return axios
      .get("filters-aldisued", {
        baseURL: this.baseURL,
        params: {
          "localization-id": localizationId || i18n.locale,
          "custompropertyvalue-ids": customProps
        },
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function(response) {
        return response;
      })
      .catch(function(error) {
        console.log(error);
      });
  }
};
